import React from 'react';

/* ── ComingSoonModal — design premium, logique préservée ────────── */
export const ComingSoonModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">

      {/* Backdrop — ferme la modale au clic */}
      <div
        className="absolute inset-0 backdrop-blur-md cursor-pointer"
        style={{ background: 'rgba(2,9,21,0.82)' }}
        onClick={onClose}
      />

      {/* Card wrapper */}
      <div className="relative max-w-md w-full animate-scaleIn z-10">

        {/* Gradient border (1px) */}
        <div
          className="absolute -inset-[1px] rounded-2xl pointer-events-none"
          style={{
            background: 'linear-gradient(135deg, rgba(0,242,254,0.55), rgba(79,172,254,0.35), rgba(168,85,247,0.45))',
          }}
        />

        {/* Card content */}
        <div
          className="relative rounded-2xl p-8 overflow-hidden"
          style={{
            background: 'linear-gradient(160deg, rgba(8,16,42,0.98) 0%, rgba(10,8,30,0.98) 100%)',
            boxShadow: '0 0 70px rgba(0,242,254,0.14), 0 40px 100px rgba(0,0,0,0.65)',
          }}
        >
          {/* Ambient corner glows */}
          <div
            className="absolute top-0 right-0 w-60 h-60 pointer-events-none"
            style={{
              background: 'radial-gradient(circle, rgba(0,242,254,0.10) 0%, transparent 70%)',
              filter: 'blur(24px)',
            }}
          />
          <div
            className="absolute bottom-0 left-0 w-48 h-48 pointer-events-none"
            style={{
              background: 'radial-gradient(circle, rgba(168,85,247,0.07) 0%, transparent 70%)',
              filter: 'blur(24px)',
            }}
          />

          {/* Top highlight */}
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#00f2fe]/40 to-transparent pointer-events-none" />

          <div className="text-center relative z-10">
            {/* Rocket with glow */}
            <div
              className="text-5xl mb-5 inline-block"
              style={{ filter: 'drop-shadow(0 0 14px rgba(0,242,254,0.45))' }}
            >
              🚀
            </div>

            <h3 className="font-outfit text-2xl sm:text-3xl font-bold mb-4 text-gradient-animated">
              Un instant d'anticipation !
            </h3>

            <p className="text-white/70 text-sm sm:text-base mb-8 leading-relaxed">
              Ce service incroyable se peaufine en coulisses. Laissez-nous un message en bas de page
              pour être prévenu en exclusivité dès son lancement. Votre patience sera récompensée !
            </p>

            {/* Close button — gradient */}
            <button
              onClick={onClose}
              className="inline-flex items-center justify-center px-8 py-3 rounded-xl font-semibold text-sm transition-[opacity,transform] duration-150 active:scale-[0.96] hover:opacity-90"
              style={{
                background: 'linear-gradient(135deg, #00f2fe, #4facfe)',
                color: '#030a1a',
                boxShadow: '0 0 28px rgba(79,172,254,0.38)',
              }}
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
